import { EPriceVariant } from '@/types/HarvestSaleLots'

export const templatePriceVariants = Object.values(EPriceVariant)
